import React, { Component, Fragment } from 'react'
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';

export class ContactPage extends Component {

  componentDidMount(){
    window.scroll(0,0);
  }



  render() {
    return (
     <Fragment>
        <TopNavigation></TopNavigation>
        <PageTop pageTitle="Contact Us"></PageTop>
        <Contact></Contact>
        <Footer></Footer>


     </Fragment>
    )
  }
}

export default ContactPage
